import React from "react";
import { Input } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

export default function MaskPassword({ onChange, fieldId, formData, placeholder, onKeyUp }) {

    return (
        <Input.Password
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            value={formData?.[fieldId] ?? ""}
            placeholder={placeholder}
            onChange={(e) => onChange(fieldId, e.target.value)}
            style={{ borderRadius: "6px" }}
            size="small"
            onKeyDown={(e) => onKeyUp(e)}
        />
    )
}
